import { plaintextValidator } from '../fields';
import { stringMandateConstraints } from '../utils';

const config = { mandatory: true };

export const clientContractConstraints = {
  name: plaintextValidator(config),
  selectedItems: {
    array: {
      // subscriptionType: stringMandateConstraints,
      ['frequency.type']: stringMandateConstraints,
      effectiveDate: plaintextValidator(config),
      unitPrice: plaintextValidator(config)
    }
  },
  selectedCustomItems: {
    array: {
      discountRate: stringMandateConstraints
    }
  }
};

export const newClientContractConstraints = {
  name: plaintextValidator(config),
  selectedItems: {
    array: {
      // subscriptionType: stringMandateConstraints,
      ['frequency.type']: stringMandateConstraints,
      billDate: plaintextValidator(config),
      unitPrice: plaintextValidator(config)
    }
  },
  selectedCustomItems: {
    array: {
      discountRate: stringMandateConstraints
    }
  }
};
